import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

const fetchCoursesIsNew = async (courseIds) => {
  const url = `${getConfig().LMS_BASE_URL}/blendxapi/discovery/courses/is-new/`;
  const { data } = await getAuthenticatedHttpClient().post(url, {
    course_ids: courseIds,
  });
  return data;
};

export const useCoursesIsNew = (courseIds) => {
  const uniqueIds = useMemo(
    () => Array.from(new Set((courseIds || []).filter(Boolean))).sort(),
    [courseIds],
  );

  const { data } = useQuery({
    queryKey: ['coursesIsNew', uniqueIds],
    queryFn: () => fetchCoursesIsNew(uniqueIds),
    enabled: uniqueIds.length > 0,
    staleTime: 30 * 1000,
  });

  return {
    isNewByCourseId: data || {},
  };
};
